<div class="document-buttons" #tabStrip
     [ngClass]="{ 'document-buttons-chico': document_buttons_chico, 'can-scroll-left': canScrollLeft, 'can-scroll-right': canScrollRight }"
     (scroll)="onTabScroll()">
  <div *ngIf="!draft">
     <div id="btn-campaign" class="document-button" [ngClass]="activeForm == 'campaign' ? 'selected' : ''"
      (click)="emitchangeForm('campaign')">
      <button type="submit" class="btn-documents">
        <i class="icon-bullhorn"></i>
        {{ "forms.buttons.campaign" | translate }}
        <span *ngIf="updatesTabs.includes('campaign')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-general" class="document-button" [ngClass]="activeForm == 'general' ? 'selected' : ''"
      (click)="emitchangeForm('general')">
      <button type="submit" class="btn-documents">
        <i class="icon-clipboard-empty"></i>
        {{ "forms.buttons.pers" | translate }}
        <span *ngIf="updatesTabs.includes('general')" class="violet-dot"></span>
      </button>
    </div>

  </div>
  <div *ngIf="draft">
    <div id="btn-general" class="document-button" [ngClass]="activeForm == 'general' ? 'selected' : ''"
      (click)="emitchangeForm('general')" *ngIf="!hideTab('general')">
      <button type="submit" class="btn-documents">
        <i class="icon-clipboard-empty"></i>
        {{ "forms.buttons.general" | translate }}
        <span *ngIf="updatesTabs.includes('general')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-vehicle" class="document-button" [ngClass]="activeForm == 'vehicle' ? 'selected' : ''"
      (click)="emitchangeForm('vehicle')" *ngIf="!hideTab('vehicle')">
      <button type="submit" class="btn-documents">
        <i class="icon-car"></i>
        {{ "forms.buttons.vehicle" | translate }}
        <span *ngIf="updatesTabs.includes('vehicle')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-details" class="document-button" [ngClass]="activeForm == 'details' ? 'selected' : ''"
      (click)="emitchangeForm('details')" *ngIf="!hideTab('details')">
      <button type="submit" class="btn-documents">
        <i class="icon-papers"></i>
        {{ "forms.buttons.details" | translate }}
        <span *ngIf="updatesTabs.includes('details')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-currency" class="document-button" [ngClass]="activeForm == 'currency' ? 'selected' : ''"
      (click)="emitchangeForm('currency')" *ngIf="!hideTab('currency')">
      <button type="submit" class="btn-documents">
        <i class="icon-bag-dollar"></i>
        {{ "forms.buttons.currency" | translate }}
        <span *ngIf="updatesTabs.includes('currency')" class="violet-dot"></span>
      </button>
    </div>

    <div id="btn-client" class="document-button" [ngClass]="activeForm == 'client' ? 'selected' : ''"
      (click)="emitchangeForm('client')" *ngIf="!hideTab('client')">
      <button type="submit" class="btn-documents">
        <i class="icon-user"></i>
        {{ "forms.buttons.client" | translate }}
        <span *ngIf="updatesTabs.includes('client')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-guarantee" class="document-button" [ngClass]="activeForm == 'guarantee' ? 'selected' : ''"
      (click)="emitchangeForm('guarantee')" *ngIf="!hideTab('guarantee')">
      <button type="submit" class="btn-documents">
        <i class="icon-user-lock"></i>
        {{ "forms.buttons.guarantee" | translate }}
        <span *ngIf="updatesTabs.includes('guarantee')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-doc-order" class="document-button" [ngClass]="activeForm == 'doc-order' ? 'selected' : ''"
      (click)="emitchangeForm('doc-order')">
      <button type="submit" class="btn-documents">
        <i class="icon-files"></i>
        {{ "forms.buttons.doc-order" | translate }}
        <span *ngIf="updatesTabs.includes('doc-order')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-risk" class="document-button" [ngClass]="activeForm == 'risk' ? 'selected' : ''"
      (click)="emitchangeForm('risk')" *ngIf="!hideTab('risk')">
      <button type="submit" class="btn-documents">
        <i class="icon-chart-bars"></i>
        {{ "forms.buttons.risk" | translate }}
        <span *ngIf="updatesTabs.includes('risk')" class="violet-dot"></span>
      </button>
    </div>
     <div id="btn-preparation" class="document-button" [ngClass]="activeForm == 'preparation' ? 'selected' : ''"
      (click)="emitchangeForm('preparation')" *ngIf="!hideTab('preparation')">
      <button type="submit" class="btn-documents">
        <i class="icon-calendar-insert"></i>
        {{ "buttons.preparation" | translate }}
        <span *ngIf="updatesTabs.includes('preparation')" class="violet-dot"></span>
      </button>
    </div>

    
    <div id="btn-delivery" class="document-button" [ngClass]="activeForm == 'delivery' ? 'selected' : ''"
      (click)="emitchangeForm('delivery')" *ngIf="!hideTab('delivery')">
      <button type="submit" class="btn-documents">
        <i class="icon-calendar-insert"></i>
        {{ "forms.buttons.delivery" | translate }}
        <span *ngIf="updatesTabs.includes('delivery')" class="violet-dot"></span>
      </button>
    </div>

    <div id="btn-notes" class="document-button" [ngClass]="activeForm == 'telemarketing' ? 'selected' : ''"
      (click)="emitchangeForm('telemarketing')" *ngIf="!hideTab('telemarketing')">
      <button type="submit" class="btn-documents">
        <i class="icon-headset"></i>
        {{ "forms.buttons.telemarketing" | translate }}
        <span *ngIf="updatesTabs.includes('telemarketing')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-notes" class="document-button" [ngClass]="activeForm == 'notes' ? 'selected' : ''"
      (click)="emitchangeForm('notes')" *ngIf="!hideTab('notes')">
      <button type="submit" class="btn-documents">
        <i class="icon-register"></i>
        {{ "forms.buttons.notes" | translate }}
        <span *ngIf="updatesTabs.includes('notes')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-commission" class="document-button" [ngClass]="activeForm == 'commission' ? 'selected' : ''"
      (click)="emitchangeForm('commission')" *ngIf="!hideTab('commission')">
      <button type="submit" class="btn-documents">
        <i class="icon-percent"></i>
        {{ "forms.buttons.commission" | translate }}
        <span *ngIf="updatesTabs.includes('commission')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-timeline" class="document-button" [ngClass]="activeForm == 'timeline' ? 'selected' : ''"
      (click)="emitchangeForm('timeline')" *ngIf="!hideTab('timeline')">
      <button type="submit" class="btn-documents">
        <i class="icon-align-left"></i>
        {{ "forms.buttons.timeline" | translate }}
        <span *ngIf="updatesTabs.includes('timeline')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-duplicate-offer" class="document-button" [ngClass]="activeForm == 'duplicate-offer' ? 'selected' : ''"
      (click)="emitchangeForm('duplicate-offer')" *ngIf="showDuplicateTab">
      <button type="submit" class="btn-documents">
        <i class="icon-copy"></i>
        {{ "forms.buttons.duplicate" | translate }}
      </button>
    </div>
  </div>
</div>
